import React from 'react'

import { CircleErrorIcon as CircleErrorIconBase, Dialog as BaseDialog } from '@chilecompra/react-kit/components'
import { Grid as BaseGrid, styled } from '@mui/material'

export const CircleErrorIcon = styled(({ fontSize, ...props }) => <CircleErrorIconBase {...props} />)`
  &.MuiSvgIcon-root {
    font-size: ${props => props.fontSize};
  }
`

export const Dialog = styled(BaseDialog)`
  // FIXME: it has to be like this until the Dialog component has a cleaner way to set the backdrop
  // background color.
  background-color: transparent;

  &:focus-visible {
    outline: 0;
  }
`

export const Row = styled(({ margin, ...props }) => <BaseGrid container {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`

export const Column = styled(({ flexGrow, margin, padding, width, textAlign, ...props }) => (
  <BaseGrid item {...props} />
))`
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '0'};
  width: ${props => props.width};
`

export const Strong = styled('span')`
  font-weight: bold;
`
